import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import DestinationsMapFixed from '../../components/BrandHomePage/DestinationsMap/DestinationsMapFixed';
import AccommodationsList from '../../components/AccommodationsList/AccommodationsList';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import { images } from '../../components/shared/assets';
import '../../styles/property-pages.css';

const AccommodationsIguazu: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();

  useEffect(() => {
    initializeAllFeatures();
    setHoveredDestination(null);
  }, [setHoveredDestination]);

  const accommodations = [
    {
      id: 'villas',
      title: 'Villas',
      description: 'Living area and coffee corner. Private terrace and plunge pool. Bathroom with bathtub and walk-in shower. Measuring 100 sq m / 1080 sq ft.',
      images: [images.villas13, images.villaExterior, images.villaInterior],
      ctaLink: '/contact',
      detailsLink: '/contact'
    },
    {
      id: 'master-villa',
      title: 'Master Villa',
      description: 'Two bedrooms & two bathrooms. Shared living area and coffee corner. Private terrace and plunge pool. Measuring 120 sq m / 1300 sq ft.',
      images: [images.masterVilla, images.villaInterior, images.villas13],
      ctaLink: '/contact',
      detailsLink: '/contact'
    }
  ];

  const communalAreas = [
    {
      title: "Guests Only Relais & Châteaux Restaurant",
      description: "Awasi Iguazú restaurant crafts dishes rooted in local ingredients and inspired by the culinary traditions of the region. Chef Mauricio Alvez creates an experience as rich and authentic as the surrounding landscape."
    },
    {
      title: "Main Lodge",
      description: "Open Bar, Indoor Living Room, Lounges and Outdoor Terrace"
    }
  ];

  return (
    <div className="property-page">
      {/* Navigation */}
      <UnifiedNavigation variant="light" destination="iguazu" />
      
      {/* Accommodations List Component */}
      <AccommodationsList
        variant="iguazu"
        heroTitle="Villas nested in the Atlantic Rainforest"
        heroImage={images.iguazuHero || images.video1}
        subheaderText=""
        introText="The 13 standard Villas have surface areas of 100 square meters, whilst the two-bedroom Master Villa spans 120 square meters. They all have spacious living rooms and outside decking complete with sun loungers and personal plunge pools. Surrounded by jungle foliage, the stand-alone. Villas are connected to the main lodge by stone walkways."
        accommodations={accommodations}
        communalAreas={communalAreas}
        communalAreasImage={images.restaurantFeature}
        fullLandscapeImage={images.producingNaturePage.fullDesertLandscape}
      />

      {/* Map Section */}
      <section className="iguazu-map-wrapper" style={{ background: 'var(--color-off-white)', padding: '80px 0' }}>
        <DestinationsMapFixed />
      </section>

      {/* Instagram Section */}
      <InstagramSection 
        title="Follow us on Instagram @awasiexperience"
        posts={[
          { src: images.film13, alt: "Instagram 1" },
          { src: images.filmVideo1, alt: "Instagram 2", isVideo: true },
          { src: images.film14, alt: "Instagram 3" },
          { src: images.film15, alt: "Instagram 4" }
        ]}
      />

      {/* Footer */}
      <Footer variant="iguazu" />
    </div>
  );
};

export default AccommodationsIguazu;